import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  OrderSummary,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.owner}owners/${COMMON_QUERY_PARAMS.OWNER_ID}/orders`;

export interface GetOrderByOwnerIdPayload {
  ownerId: string;
}

export const getOrderByOwnerIdRequest = (
  payload: GetOrderByOwnerIdPayload,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.OWNER_ID, payload.ownerId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getOrderByOwnerId = async (
  payload: GetOrderByOwnerIdPayload,
): Promise<BackResponse<OrderSummary[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<OrderSummary[]>>(
      getOrderByOwnerIdRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getOrderByOwnerId;
